// extracted by mini-css-extract-plugin
export default {"title":"SupplyChainIncidents_title__WL3rk","icon":"SupplyChainIncidents_icon__3UihK","link":"SupplyChainIncidents_link__AVSUG"};